export default __webpack_public_path__ + "static/media/name_it.f3b758a6.png";